import React from "react";
import styled from "styled-components";
import { Card, Statistic, Progress } from "antd";

const StyledStatsCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }

  .ant-card-body {
    padding: 24px;
  }
`;

const StatsCard = ({
  title,
  value,
  prefix,
  valueStyle,
  progressPercent,
  strokeColor,
}) => {
  return (
    <StyledStatsCard>
      <Statistic
        title={title}
        value={value}
        prefix={prefix}
        valueStyle={valueStyle}
      />
      <Progress
        percent={progressPercent}
        size="small"
        strokeColor={strokeColor}
      />
    </StyledStatsCard>
  );
};

export default StatsCard;
